import { Component } from '@angular/core';

@Component({
	templateUrl: '../../../../../../assets/svg/history.svg',
})
export class HistoryComponent {}
